import { render } from "./eventsListD.vue?vue&type=template&id=4a3c4e3a&scoped=true"
import script from "./eventsListD.vue?vue&type=script&lang=js"
export * from "./eventsListD.vue?vue&type=script&lang=js"

import "./eventsListD.vue?vue&type=style&index=0&id=4a3c4e3a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/pescle-rodent/pescle-rodent/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a3c4e3a"]])

export default __exports__